import React from 'react'
import { FaFilePdf } from 'react-icons/fa'
import {
  Button,
  Container,
  Element,
  Heading,
  Image,
  Section,
  Columns,
} from 'react-bulma-components'
import Layout from '../components/layout/layout'
import { Translate } from '../utils/translations'
import { OptimizedImage } from '../components/optimized-image'
import { setTranslations } from 'react-i18nify'
import { campaign } from '../campaigns'

/**
 * Standalone repair kit instructions page for the active campaign.
 * Shows the product recall title, product image, tutorial video and repair notice PDF.
 */
const RepairKitPage: React.FC = () => {
  setTranslations(campaign.presentationLocales)

  const videoEmbedUrl = campaign.repair!.videoUrl
  const pdfUrl = campaign.repair!.pdfUrl
  const kitImageName = campaign.repair!.kitImageName

  return (
    <Layout>
      <Image src={campaign.logo} style={{ maxWidth: 320, margin: 'auto' }} />
      <Section pb={2} mb={5}>
        <Container>
          <Heading size={3} textAlign="center" mb={6}>
            <Translate value="title" />
          </Heading>

          <Heading size={4} textAlign="center" mb={5}>
            <Translate value="repair.title" />
          </Heading>

          {(kitImageName || videoEmbedUrl) && (
            <Columns vCentered mb={6}>
              {kitImageName && (
                <Columns.Column size={6} mobile={{ size: 12 }} style={{ textAlign: 'center' }}>
                  <OptimizedImage
                    imageName={kitImageName}
                    alt="SD500 / EMD500E repair kit"
                    priority={true}
                    loading="eager"
                  />
                </Columns.Column>
              )}

              {videoEmbedUrl && (
                <Columns.Column
                  size={kitImageName ? 6 : 12}
                  mobile={{ size: 12 }}
                  textAlign="center"
                >
                  <Element
                    style={{
                      position: 'relative',
                      width: '100%',
                      paddingBottom: '56.25%',
                      height: 0,
                      overflow: 'hidden',
                      borderRadius: 4,
                    }}
                  >
                    <iframe
                      src={videoEmbedUrl}
                      title="Repair tutorial video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                      }}
                    />
                  </Element>
                </Columns.Column>
              )}
            </Columns>
          )}

          {pdfUrl && (
            <Element style={{ textAlign: 'center' }}>
              <Button
                color="primary"
                renderAs="a"
                href={pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                download
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  maxWidth: '100%',
                  minHeight: 'auto',
                  padding: '22px 16px',
                  fontSize: '14px',
                  lineHeight: '1.4',
                }}
              >
                <FaFilePdf size={20} aria-hidden="true" />
                <Translate value="repair.docLabel" />
              </Button>
            </Element>
          )}
        </Container>
      </Section>
    </Layout>
  )
}

export default RepairKitPage
